import React from 'react';

import styles from './LoadingIndicator.module.css';

type LoadingIndicatorProps = {
  /** 表示するメッセージ。デフォルトは「読み込み中...」 */
  message?: string;
  /** コンテナのアラインメント。デフォルトはcenter */
  align?: 'left' | 'center' | 'right';
  /** 追加のクラス名 */
  className?: string;
};

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  message = '読み込み中...',
  align = 'center',
  className
}) => {
  const containerClassName = [
    styles['loading-indicator'],
    styles[`loading-indicator-${align}`],
    className
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={containerClassName} role="status" aria-live="polite">
      <span className={styles['loading-indicator-spinner']} aria-hidden="true" />
      <span className={styles['loading-indicator-message']}>{message}</span>
    </div>
  );
};

export default LoadingIndicator;
